import styled from 'styled-components'

export const CarouselStyled = styled.div`
  width: 100%;
`
